import { datasource } from "./datasource";

export const thumbCutDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("thumb_cut", {
    model: {
      id: "id",
      fields: {
        id: {
          type: "string",
        },
        spec_sheet_id: {
          type: "string",
        },
        cut_number: {
          type: "number",
        },
        v: {
          type: "string",
        },
        h: {
          type: "string",
        },
        label: {
          type: "string",
          alter: true,
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
      },
    },
  });
